module.exports = __webpack_public_path__ + "img/56.0cc1ca32.jpg";